"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsightDefinitionBuilder = exports.newInsightDefinition = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var identity_1 = tslib_1.__importDefault(require("lodash/identity"));
/*
 * Factory & builder for insight instances. Keeping it in test infrastructure for now, will see later on
 * whether we should move it to prod code and expose on public API.
 */
/**
 * Creates new, empty insight definition, optionally modifying its content.
 *
 * @param visualizationUrl - visualization URL (e.g. local:bar, local:table..)
 * @param modifications - modification function which will be called with builder to update the insight
 * @internal
 */
function newInsightDefinition(visualizationUrl, modifications) {
    if (modifications === void 0) { modifications = identity_1.default; }
    var builder = new InsightDefinitionBuilder(visualizationUrl);
    return modifications(builder).build();
}
exports.newInsightDefinition = newInsightDefinition;
/**
 * Insight definition builder can be used to set various properties of the insight using fluent API.
 *
 * @internal
 */
var InsightDefinitionBuilder = /** @class */ (function () {
    function InsightDefinitionBuilder(visualizationUrl) {
        var _this = this;
        this.title = function (title) {
            _this.insight.title = title;
            return _this;
        };
        this.buckets = function (buckets) {
            _this.insight.buckets = buckets;
            return _this;
        };
        this.filters = function (filters) {
            _this.insight.filters = filters;
            return _this;
        };
        this.sorts = function (sorts) {
            _this.insight.sorts = sorts;
            return _this;
        };
        this.properties = function (properties) {
            _this.insight.properties = properties;
            return _this;
        };
        this.build = function () {
            return {
                insight: _this.insight,
            };
        };
        this.insight = {
            visualizationUrl: visualizationUrl,
            title: "Untitled",
            buckets: [],
            filters: [],
            sorts: [],
            properties: {},
        };
    }
    return InsightDefinitionBuilder;
}());
exports.InsightDefinitionBuilder = InsightDefinitionBuilder;
//# sourceMappingURL=factory.js.map